import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  cheerUpBanner: {
    border: '3px solid #3966f8',
    color: '#3966f8',
    padding: '1.5rem',
    borderRadius: '1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  cheerUpBannerText: {
    fontSize: '1.625rem',
    textAlign: 'center',
    fontWeight: 700
  },
  cheerUpBannerIcon: {
    fontSize: '2rem',
    marginBottom: '0.5rem'
  }
}));

const SelectedNewsfeedCheerUpBanner = ({ message }) => {
  const { classes } = useStyles();

  if (!message) {
    return null;
  }

  return (
    <Box className={classes.cheerUpBanner}>
      <Typography className={classes.cheerUpBannerText}>{message}</Typography>
    </Box>
  );
};

export default SelectedNewsfeedCheerUpBanner;
